module.exports = __webpack_public_path__ + "img/volleyball.2da56af7.svg";